import { createStyles, StyledComponentProps, withStyles } from '@material-ui/core/styles';
import { computed } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { OcDataview } from '../../comps/OcDataview';
import { OcDataviewFiltering } from '../../comps/OcDataviewFiltering';
import { PleaseWait } from '../../comps/PleaseWait';
import { DataviewStore } from '../../stores/DataviewStore';
import { getOmnistore } from '../../stores/Omnistore';
import { OcScreen } from '../OcScreen';
import { OrderDetail } from './OrderDetail';

const dataviewStore = DataviewStore.create({
	id: 'OrderPage',
	orgColumns: [
		'creationTimestamp :datetime 50',
		'branchName',
		'supplierName',
		'customerNo 50',
		'orderingUserEmail 160',
		'status :Order_Status 60',
		'paymentMethod :Order_PaymentMethod 60',
		'dateAndTime :dateAndTime 50',
		'price :price 50',
		'id :int 50',
	],
	sorting: {column: 'creationTimestamp', reversed: true},
	filtering: [
		{columns: ['branchName'], type: 'SELECT'},
		{columns: ['supplierName'], type: 'SELECT'},
	],
});

dataviewStore.addColumnHiderToNamed('DEFAULT', 'orderingUserEmail', 'customerNo', 'status', 'paymentMethod');
dataviewStore.addColumnHiderToNamed('PRICE', 'price');

const styles = createStyles({
});

interface IOrderListProps {
}

@observer class _OrderPage extends OcScreen<IOrderListProps & StyledComponentProps> {
	name() {
		return 'OrderPage';
	}

	submenu() {
		return dataviewStore.isShowingSubmenu===false ? [] : [
			<OcDataviewFiltering key="filtering" state={dataviewStore} repo={this._repo}/>,
		];
	}

	@computed get _repo() {
		return getOmnistore().multirepo.orderRepo;
	}

	@computed get _hasPrice() {
		for (let e of this._repo.allAsList) {
			if (e.price) return true;
		}
		return false;
	}

	autoruns() {
		return [
			() => dataviewStore.setIgnoredColumnHiders([
				this._hasPrice ? 'PRICE' : null,
			]),
		];
	}

	usedStores = () => ['Order']

	renderBody() {
		if (!this._repo.etag) return <PleaseWait/>;
		return <React.Fragment>
			<OcDataview repo={this._repo} state={dataviewStore}/>
			<OrderDetail state={dataviewStore} entity={this._repo.byId(dataviewStore.selectedEntityId)}/>
		</React.Fragment>;
	}
}

export const OrderPage = withStyles(styles)(_OrderPage);
